<template>
  <div id="app" class="container-fluid content-wrap">
    <!-- <div class="settings-backdrop-bg"></div> -->
    <portal-target name="dash-modal" />
    <portal-target name="aux-modal" />
    <portal-target name="imgviewer-modal" class="imgviewer-portal-modal" />
    <PremiumModal />
    <div class="row settings-flex-container">
      <div v-if="!mobile_app_view && !pageProps.checkoutLayout" class="sidebar">
        <SettingsSidemenu v-if="!loading" />
      </div>

      <div class="main-content" v-if="$route.name.toLowerCase() === 'confirmpayment'" :class="[$route.name.toLowerCase()]">
        <LoadingSpinner v-if="loading" />
        <router-view v-if="!loading" />
      </div>

      <div v-else class="main-content" :class="[$route.name.toLowerCase()]">
        <div v-if="pageProps.pageTitle !== ''" class="settingstitle">
          <h2>{{ pageProps.pageTitle }}</h2>
          <CompanyPicker v-if="pageProps.showCompanyPicker && (!currentUser.is_accountant || (currentUser.is_accountant && currentCompany.has_accountant))" />
        </div>
        <div class="setting-content">
          <LoadingSpinner v-if="loading" />
          <router-view v-if="!loading"/>
        </div>
      </div>
      
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import CompanyPicker from "@/components/CompanyPicker";
import SettingsSidemenu from "@/components/SettingsSidemenu";
import PremiumModal from "@/components/PremiumModal.vue";
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"

export default {
  name: "Settings",
  components: {
    CompanyPicker,
    SettingsSidemenu,
    PremiumModal,
    LoadingSpinner
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title + ' - Gekko'
        document.body.classList.remove('modal-on')

      }
    }
  },
  data () {
    return {
      mobile_app_view: window.mobile_app_view,
      loading: false
    }
  },
  computed: {
    ...mapGetters({ 
      pageProps: "pagePropertiesStore/getPageProperties",
      currentCompany: "main/getCurrentCompany",
      currentUser: "main/getCurrentUser"
    })
  },
  created () {
    this.$language.current = window.preferred_language;
    this.$store.commit('setRoot', this.$root)
    this.setupData()
  },
  methods: {
    ...mapActions({ 
      loadMainGlobalData: "main/loadMainGlobalData"
    }),
    setupData () {
      this.loading = true
      this.loadMainGlobalData().then(() => {
        this.$store.commit('setIsPremium', this.currentCompany.is_premium)
        this.$store.commit('main/SET_CONSTANTS')
        this.loading = false
      })
    }
  },
};
</script>
<style lang="scss" scoped>
  .container-fluid {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;
  }
</style>

<style lang="scss">
  .setting-content {
    padding: 0;
    &--section {
      padding: 1rem;
      border-radius: $radiusLg;
      box-shadow: $settingShadow;
      background: white;
      .setting-table--wrap {
        width: 100%;
        overflow: hidden;
        overflow-x: auto;
      }
      legend {
        margin: 0;
      }
    }
  }

  body#settings-base .sidebar {
    // flex: 0;
    // width: 237px; // FIXME

    flex: 1;
    max-width: 270px;
  }

  body#settings-base,
  body#settings-base .main-content {
    background: #f2f2f2;
  }

  body#settings-base .main-content {
    margin-top: 0px;
    flex: 1 1 0;
    width: calc(100% - 237px); // FIXME

    .table-responsive { margin-bottom: 0; }
  }
  @media(max-width: '650px') {
    body#settings-base .sidebar,
    body#settings-base .main-content {
      flex: 1;
      width: 100%;
    }
  }

  body#settings-base .main-content {
    .settingstitle {
      position: relative;
      z-index: 2;
      padding-bottom: 1rem;
        h2 { font-size: 24px; line-height: 1.2; }
    }
  }  
  
  @media(min-width: '768px') {
    body#settings-base .main-content {
      .settingstitle {
        h2 { font-size: 28px; line-height: 1.5; }
      }
    }
  }

  body#settings-base .main-content.confirmpayment {
    padding: 0;
    background: #f9f9f9;
    background: linear-gradient(165deg, #c0e5dcb3 0%, white 50%);
    display: flex;
    flex-direction: column;
    .checkout-wrap {
      display: flex;
      flex-direction: column;
    }
    .adyen-container {
      background: white;
    }
  }

  @media(min-width: '768px') {
    body#settings-base .main-content.confirmpayment {
      .checkout-wrap {
        flex-direction: row;
        .adyen-container {
          box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
        }
      }
    }
  }
  
  .breadcrumb.payment-breadcrumbs {
    background-color: white;
    padding-left: 0;
    padding-right: 0;
    font-size: 16px;
  }
  .checkout-breadcrumbs {
    padding: 0.75rem 0;
    font-size: 16px;
  }

  .vue-portal-target {
    z-index: 1100;
  }
  
  .imgviewer-portal-modal {
    z-index: 1200;
  }
  // testing with bgs, disabled
  // .settings-backdrop-bg {
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   width: 100vw;
  //   height: 100vh;
  //   background-image: url("https://source.unsplash.com/featured/1920x1080");
  //   background-size: cover;
  //   z-index: 0;
  //   filter: blur(7px);
  // }
  // .sidebar { z-index: 1; }

  // body#settings-base,
  // body#settings-base .main-content {
  //   background: none !important;
  //   z-index: 1 !important;
  // }
  // .setting-content--section {
  //   background: rgba(255,255,255,0.7) !important;
  //   backdrop-filter: blur(7px) !important;
  // }
</style>
